// src/services/customerApi.js
// Servicio para manejar operaciones relacionadas con clientes

import { dotoniwoofApi } from '../api/dotoniwooApi';

/**
 * Registra un nuevo cliente con su información de persona asociada
 * @param {Object} customerData - Datos del cliente y persona
 * @param {string} customerData.email - Email del cliente
 * @param {string} customerData.phone_whatsapp - Teléfono WhatsApp
 * @param {string} [customerData.phone_2] - Teléfono secundario (opcional)
 * @param {string} customerData.timezone - Zona horaria
 * @param {number} customerData.marketing_opt_in - Acepta marketing (0 o 1)
 * @param {Object} customerData.person - Datos de la persona
 * @returns {Promise<Object>} Respuesta de la API
 */
export const createCustomer = async (customerData) => {
  try {
    console.log('Enviando datos del cliente:', customerData);
    
    const response = await dotoniwoofApi.post('/client.php', customerData);
    
    console.log('Respuesta del servidor:', response.data);
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al crear cliente:', error);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Obtiene la lista de clientes con paginación y búsqueda
 * @param {Object} params - Parámetros de consulta
 * @param {number} params.page - Número de página (por defecto 1)
 * @param {number} params.per_page - Elementos por página (1-100, por defecto 20)
 * @param {string} params.q - Término de búsqueda (opcional)
 * @returns {Promise<Object>} Lista de clientes con metadatos de paginación
 */
export const getCustomers = async ({ page = 1, per_page = 20, q = '' } = {}) => {
  try {
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('per_page', per_page.toString());
    if (q) params.append('q', q);
    
    const response = await dotoniwoofApi.get(`/client.php?${params.toString()}`);
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al obtener clientes:', error);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Obtiene un cliente por su ID
 * @param {number} customerId - ID del cliente
 * @returns {Promise<Object>} Datos del cliente
 */
export const getCustomerById = async (customerId) => {
  try {
    const response = await dotoniwoofApi.get(`/client.php/${customerId}`);
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al obtener cliente:', error);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Actualiza un cliente existente
 * @param {number} customerId - ID del cliente
 * @param {Object} customerData - Nuevos datos del cliente
 * @param {string} [customerData.email] - Email del cliente
 * @param {string} [customerData.phone_whatsapp] - Teléfono WhatsApp
 * @param {string} [customerData.phone_2] - Teléfono secundario (opcional)
 * @param {string} [customerData.timezone] - Zona horaria
 * @param {number} [customerData.marketing_opt_in] - Acepta marketing (0 o 1)
 * @param {Object} [customerData.person] - Datos de la persona
 * @returns {Promise<Object>} Respuesta de la API
 */
export const updateCustomer = async (customerId, customerData) => {
  try {
    console.log('Actualizando cliente:', customerId, customerData);
    
    const response = await dotoniwoofApi.put(`/client.php/${customerId}`, customerData);
    
    console.log('Respuesta del servidor:', response.data);
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al actualizar cliente:', error);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Elimina un cliente
 * @param {number} customerId - ID del cliente
 * @returns {Promise<Object>} Respuesta de la API
 */
export const deleteCustomer = async (customerId) => {
  try {
    const response = await dotoniwoofApi.delete(`/client.php/${customerId}`);
    
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al eliminar cliente:', error);
    
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};
